<template>
    <div class="page-width">
      <div class='confirmation'>
        <div v-if="orderLoading && !orderSuccessful" class="pending-confirmation">
        <h2>{{ $t('pendingConfirmation') }}</h2>
        <div class="svg">
            <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              width="80px" height="80px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <path fill="#ff6f37" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                <animateTransform attributeType="xml"
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="1s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
        </div>
            <a>{{ $t('waitProcessing') }}</a>
        </div>
        <div v-else-if="!orderLoading && orderSuccessful" class="confirmation-confirmed">
          <h2>{{ $t('orderSuccessful') }}</h2>
          <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" viewBox="0 0 24 24"><path fill="#ff6f37" d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
          <a>{{ $t('congrats') }}</a>
        </div>
        <div v-else-if="!orderLoading && !orderSuccessful" class="confirmation-confirmed">
          <h2>{{ $t('noOrdersSubmitted') }}</h2>
        </div>
      </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: 'confirmation',
  data() {
    return {
      interval: null,
    }
  },
  created() {
    this.searchForId();
  },
  beforeDestroy() {
    this.stopSearchForId();
  },
  methods: {
    ...mapMutations('checkout', ['clearOrderData']),
    checkForConfirmation() {
      this.$store.dispatch('checkout/confirmSalesOrder', this.salesOrderId)
    },
    searchForId() {
      var that = this;
      if (this.orderLoading && !this.orderSuccessful) {
      this.interval = setInterval(function() {
          that.checkForConfirmation();
        }, 4000);
      }
    },
    stopSearchForId() {
      clearInterval(this.interval);
    },
  },
  beforeRouteLeave(to, from, next) {
    this.stopSearchForId();
    this.clearOrderData();
    next();
  },
  computed: mapState({
    orderSuccessful: state => state.checkout.orderSuccessful,
    orderLoading: state => state.checkout.orderLoading,
    salesOrderId: state => state.checkout.salesOrderId,
  })
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/confirmation.less";
</style>



// WEBPACK FOOTER //
// src/view/confirmation.vue